<template>
  <div></div>
</template>

<script>
const wx = require("jweixin-module");
export default {
  data() {
    return {};
  },
  created() {
    
  },
  beforeMount() {
    document.title = "E链签";
  },
  mounted() {
    wx.miniProgram.switchTab({
      url: "/pages/workbench/Workbench",
    });
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>